import React from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Input,
  Row,
  CardTitle,
  CardText,
  CardHeader,
} from "reactstrap";
import { useEffect, useState } from "react";
import { addChequeBounceCharges, getPaymntGistory } from "../../util/APIUtils";
import PymntHstryBody from "./PymntHstryBody";
import { LoadingOverlay } from "../../util/Helpers";
import { ButtonStyles } from "../../constants/ButtonStyles";
export default function PaymentHistory() {
  const [values, setValues] = useState({
    frmDate: new Date().toISOString().substring(0, 10),
    toDate: new Date().toISOString().substring(0, 10),
  });
  const [trans, setTrans] = useState([]);
  const [block, setBlock] = useState(false);
  const [open, setOpen] = useState(false);
  const [contextMenuPosition, setContextMenuPosition] = useState({
    x: 0,
    y: 0,
  });
  const [currentRow, setCurrentRow] = useState({});
  useEffect(() => {
    loadReqData();
  }, []);

  const toggle = () => {
    setOpen(!open);
  };
  const selectedOption = (option) => {
    if (option == 1) {
      addChequePenality();
    }
  };
  const addChequePenality = () => {
    setBlock(true);
    addChequeBounceCharges(values).then((response) => {
      swal({
        text: "Added Cheque Bounce charges succesfully",
      });
      setBlock(false);
    });
  };
  const handleRightClick = (e, row) => {
    //  e.preventDefault();
    setContextMenuPosition({ x: e.clientX, y: e.clientY });
    setOpen(true);
    setCurrentRow(row);
  };
  const loadReqData = () => {
    setBlock(true);
    getPaymntGistory(values).then((response) => {
      setTrans(response);
      setBlock(false);
    });
  };

  const onChangeNotesMap = ({ target }) => {
    const { name, value } = target;
    setValues((previousState) => ({
      ...previousState,
      [name]: value,
    }));
  };

  const updateMap = (e) => {
    if (Object.keys(values).length !== 2) {
      return false;
    }
    setBlock(true);
    getPaymntGistory(values).then((response) => {
      setBlock(false);
      setTrans(response);
    });
  };
  const clearAll = (e) => {
    setValues({
      frmDate: new Date().toISOString().substring(0, 10),
      toDate: new Date().toISOString().substring(0, 10),
    });
  };

  return (
    <div>
      {block && <LoadingOverlay />}
      <Card style={{
        borderRadius: "15px",
        boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
        border: "none",
        overflow: "hidden"
      }}>
        <CardHeader style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          padding: "20px 25px",
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: "none"
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <i className="fa fa-history" style={{ fontSize: "24px", color: "#fff" }}></i>
            <strong style={{ fontSize: '1.2rem', color: "#fff" }}>Payment History</strong>
          </div>
        </CardHeader>
        <CardBody style={{ padding: "25px" }}>
          <Row className="mb-3" style={{ alignItems: "center" }}>
            <Col sm="3">
              <Input
                bsSize="sm"
                type="date"
                name="frmDate"
                id="frmDate"
                onChange={onChangeNotesMap}
                value={values.frmDate}
                style={{ borderRadius: "8px", border: "1px solid #e0e0e0", padding: "8px 12px" }}
              />
            </Col>
            <Col sm="3">
              <Input
                bsSize="sm"
                type="date"
                name="toDate"
                id="toDate"
                onChange={onChangeNotesMap}
                value={values.toDate}
                style={{ borderRadius: "8px", border: "1px solid #e0e0e0", padding: "8px 12px" }}
              />
            </Col>
            <Col sm="3">
              <Button style={{ ...ButtonStyles.primarySm, marginRight: "10px" }} onClick={updateMap}>
                <i className="fa fa-search" style={{ marginRight: "5px" }} />Go
              </Button>
              <Button style={ButtonStyles.secondarySm} onClick={clearAll}>
                <i className="fa fa-times" style={{ marginRight: "5px" }} />Cancel
              </Button>
            </Col>
            <Col sm="3" />
          </Row>
          <Row style={{ marginBottom: "25px" }}>
            <Col sm="3">
              <Card style={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                borderRadius: "12px",
                border: "none",
                padding: "20px",
                color: "#fff"
              }}>
                <div style={{ fontSize: "14px", opacity: "0.9" }}>Paid</div>
                <div style={{ fontSize: "24px", fontWeight: "700" }}>83,32,378.80</div>
              </Card>
            </Col>
            <Col sm="3">
              <Card style={{
                background: "linear-gradient(135deg, #f7971e 0%, #ffd200 100%)",
                borderRadius: "12px",
                border: "none",
                padding: "20px",
                color: "#fff"
              }}>
                <div style={{ fontSize: "14px", opacity: "0.9" }}>Unpaid</div>
                <div style={{ fontSize: "24px", fontWeight: "700" }}>821.79</div>
              </Card>
            </Col>
            <Col sm="3">
              <Card style={{
                background: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
                borderRadius: "12px",
                border: "none",
                padding: "20px",
                color: "#fff"
              }}>
                <div style={{ fontSize: "14px", opacity: "0.9" }}>Overdue</div>
                <div style={{ fontSize: "24px", fontWeight: "700" }}>427118.50</div>
              </Card>
            </Col>
            <Col sm="3">
              <Card style={{
                background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                borderRadius: "12px",
                border: "none",
                padding: "20px",
                color: "#fff"
              }}>
                <div style={{ fontSize: "14px", opacity: "0.9" }}>Total</div>
                <div style={{ fontSize: "24px", fontWeight: "700" }}>87,60,319.09</div>
              </Card>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <div className="animated fadeIn" style={{ marginTop: "20px" }}>
        <PymntHstryBody
          data={trans}
          open={open}
          toggle={toggle}
          selectedOption={selectedOption}
          handleRightClick={handleRightClick}
          contextMenuPosition={contextMenuPosition}
          currentRow={currentRow}
        />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/PaymentHistory.js